const Shop = () => import('@pages/patientMeal/Shop')
const ProductsPaid = () => import('@pages/patientMeal/ProductsPaid')
const Balance = () => import('@pages/patientMeal/Balance')
const Order = () => import('@pages/patientMeal/Order')
const OrderShow = () => import('@pages/patientMeal/OrderShow')
const PhoneCode = () => import('@pages/patientMeal/PhoneCode')
const BalanceShow = () => import('@pages/patientMeal/BalanceShow')
const RechargeSuccess = () => import('@pages/patientMeal/RechargeSuccess')
const StoreSelect = () => import('@pages/patientMeal/StoreSelect')
const OrderComment = () => import('@pages/patientMeal/OrderComment')

export const patientMeal = [
  {
    path: '/patientMeal/Shop/',
    name: 'Shop',
    component: Shop,
    meta: {}
  },
  {
    path: '/patientMeal/paid/:id',
    name: 'ProductsPaid',
    component: ProductsPaid,
    meta: {}
  },
  {
    path: '/patientMeal/balance',
    name: 'Balance',
    component: Balance,
    meta: {}
  },
  {
    path: '/patientMeal/order',
    name: 'Order',
    component: Order,
    meta: {}
  },
  {
    path: '/patientMeal/order_show/:id',
    name: 'OrderShow',
    component: OrderShow,
    meta: {}
  },
  {
    path: '/patientMeal/phone_code',
    name: 'PhoneCode',
    component: PhoneCode,
    meta: {}
  },
  {
    path: '/patientMeal/balance_show',
    name: 'BalanceShow',
    component: BalanceShow,
    meta: {}
  },
  {
    path: '/patientMeal/recharge_success',
    name: 'RechargeSuccess',
    component: RechargeSuccess,
    meta: {}
  },
  {
    path: '/patientMeal/store_select',
    name: 'StoreSelect',
    component: StoreSelect,
    meta: {}
  },
  {
    path: '/patientMeal/order_comment',
    name: 'OrderComment',
    component: OrderComment,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/patientMeal.route.js